import React from 'react';
import {RefluxListener} from "sp-react-commons";

import Picker from "../components/Picker";
import MovieList from "../components/MovieList";
import * as MoviesActions from '../core/MoviesActions';
import Loader from "../components/Loader";
import IntlMessages from "../IntlMessages";
import MovieHelpers from "../utils/MovieHelpers";


const Messages = IntlMessages[MovieHelpers.getLang()];


function hasIntersect( a, b ) {
    return a.map( v => b.indexOf( v ) >= 0 ).reduce( ((x,y) => x || y), false );
}


@RefluxListener
export default class MoviesPage extends React.Component {

    state = {
        movies : null,
        countriesFilter : ['lu'],
        audioFilter : [],
        subtitlesFilter : []
    };

    componentDidMount() {
        this.listenTo(MoviesActions.getNowBookingMovies.completed, this.onMovies);
        MoviesActions.getNowBookingMovies();
    }

    componentDidUpdate() {
        window.pymChild && window.pymChild.sendHeight();
    }

    get loading() { return !this.state.movies; }

    onMovies = ({ movies }) => {
        this.setState({ movies });
    };

    updateCountryFilter = ( countriesFilter ) => {
        window.logAction();
        this.setState( { countriesFilter } );
    };

    updateAudioFilter = ( audioFilter ) => {
        window.logAction();
        this.setState( { audioFilter } );
    };

    updateSubtitlesFilter = ( subtitlesFilter ) => {
        window.logAction();
        this.setState( { subtitlesFilter } );
    };

    filterMovies = (movie) => {
        let matches = true;
        if( this.state.countriesFilter.length > 0 ) {
            matches = matches & ( movie.cinemas.filter( c => this.state.countriesFilter.indexOf( c.country ) >= 0 ).length > 0 );
        }

        if( this.state.audioFilter.length > 0 ) {
            matches = matches & (this.state.audioFilter.indexOf( movie.audio ) >= 0);
        }

        if( this.state.subtitlesFilter.length > 0 ) {
            matches = matches & hasIntersect( movie.subtitles, this.state.subtitlesFilter );
        }

        return matches;
    };

    render() {

        if(this.loading) {
            return (
                <Loader/>
            );
        }

        return (
            <div className="pure-g">
                <div className="pure-u-1 pure-u-md-4-24">
                    <Picker
                        title={Messages.countriesPickerTitle}
                        options={Messages.countries}
                        onSelect={this.updateCountryFilter}
                        default={this.state.countriesFilter}
                    />
                    <Picker
                        title={Messages.audioPickerTitle}
                        options={Messages.languages}
                        onSelect={this.updateAudioFilter}
                        default={this.state.audioFilter}
                    />
                    <Picker
                        title={Messages.subtitlesPickerTitle}
                        options={Messages.subtitles}
                        onSelect={this.updateSubtitlesFilter}
                    />
                </div>
                <div className="pure-u-1 pure-u-md-20-24">
                    <MovieList movies={this.state.movies.filter( this.filterMovies )}/>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./js/movies/pages/MoviesPage.jsx